import Button from '@jetbrains/ring-ui/components/button/button'
import {useCallback, useMemo} from 'react'

import Icon from '../../Icon/Icon'
import {RouterButton} from '../../RouterLink/RouterLink'
import type {BuildState} from '../BuildStateFilter.constants'

type Props = {
  className?: string
  iconClassName?: string
  icon?: string | null
  title?: string
  state: BuildState
  isLoading?: boolean
  isActive?: boolean
  onClick?: (state: BuildState) => void
  withLink?: boolean
  isDisabled?: boolean
}
function FilterButton({
  className,
  iconClassName,
  icon,
  title,
  state,
  isLoading,
  isDisabled,
  isActive,
  onClick: onClickExternal,
  withLink,
}: Props) {
  const content = useMemo(
    () => (icon != null ? <Icon className={iconClassName} name={icon} /> : title),
    [icon, title, iconClassName],
  )

  const onClick = useCallback(() => {
    if (onClickExternal != null) {
      onClickExternal(state)
    }
  }, [onClickExternal, state])

  const commonProps = {
    className,
    title: icon != null ? title : undefined,
    onClick,
  }

  if (withLink) {
    return (
      <RouterButton
        {...commonProps}
        isActive={isActive}
        isLoading={isLoading && isActive}
        params={{state, page: '1'}}
        withMergeParams
      >
        {content}
      </RouterButton>
    )
  }

  return (
    <Button {...commonProps} disabled={isDisabled} active={isActive} loader={isLoading && isActive}>
      {content}
    </Button>
  )
}

export default FilterButton
